const Contact = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="contact-section" id="contact">
      <h2>Contact</h2>
      <form action="">
        <input type="text" placeholder="Nom" />
        <input type="email" placeholder="Email" />
        <input type="text" placeholder="Objet" />
        <button type="submit" className="btn">
          Envoyer
        </button>
      </form>
      <div className="copyright">
        <p>© {currentYear} Ilann Barreteau. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Contact;
